import '@/styles/base.scss'
import '@/styles/style.scss'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n } from '@/i18n'

import App from './App.vue'
import router from './router'
import CoreuiVue from '@coreui/vue-pro'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import PusherPlugin from './plugins/PusherPlugin'
import VueSelect from 'vue-select'
import AppModuleTable from '@/components/AppModuleTable.vue'
import AppInitializingModule from '@/components/AppInitializingModule.vue'
import CInvalidFeedback from '@/components/CInvalidFeedback.vue'

const pusherApiKey = import.meta.env.VITE_PUSHER_KEY

const app = createApp(App)

app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('v-select', VueSelect)
app.component('AppModuleTable', AppModuleTable)
app.component('AppInitializingModule', AppInitializingModule)
app.component('CInvalidFeedback', CInvalidFeedback)

app.use(i18n)
app.use(CoreuiVue)
app.use(PusherPlugin, { pusherApiKey, pusherOptions: { cluster: 'eu' } })
app.use(createPinia())
app.use(router)

app.mount('#app')
